import React, { useState, useEffect } from 'react';
import { MDBCol, MDBRow } from 'mdbreact';
import PropTypes from 'prop-types';

import PageStructure from 'components/PageStructure';

import Slider from 'components/Slider';
import Checkbox from 'components/FormGroup/Checkbox';

import Image01 from 'assets/images/pdi-image-01.svg';
import Image02 from 'assets/images/pdi-image-02.svg';
import Image03 from 'assets/images/pdi-image-03.svg';
import Image04 from 'assets/images/pdi-image-04.svg';
import Image05 from 'assets/images/pdi-image-05.svg';
import Image06 from 'assets/images/pdi-image-06.svg';
import Image07 from 'assets/images/pdi-image-07.svg';
import Image08 from 'assets/images/pdi-image-08.svg';
import Image09 from 'assets/images/pdi-image-09.svg';
import Image10 from 'assets/images/pdi-image-10.svg';
import Image11 from 'assets/images/pdi-image-11.svg';

import * as S from './styles';

const mediationImages = [Image11, Image06];

const evaluationImages = [Image02, Image09, Image10, Image06, Image07, Image05];

const selfEvaluationImages = [
  Image01,
  Image02,
  Image03,
  Image04,
  Image05,
  Image06,
  Image07,
  Image08,
];

const allTexts = [
  {
    context: 'self-evaluation',
    texts: [
      {
        text: [
          'O formulário do PDI busca avaliar a nossa capacidade de entrega, além de mapear os pontos fortes e de melhoria. ',
          <br />,
          <br />,
          'O resultado dessa análise também auxilia na identificação de treinamentos necessários em grupo ou individuais com foco no desenvolvimento dos times.',
          <br />,
          <br />,
          ' Serão avaliados os conhecimentos em, ',
          <span>8 grandes áreas</span>,
          ' de atuação da empresa e soft skills. Você também será avaliado por seu líder técnico com base nas mesmas questões.',
          <br />,
          <br />,
          ' É essencial que as respostas da fase de autoavaliação sejam sinceras. Caso seja informada alguma certificação, será solicitado upload dos comprovantes.',
        ],
        numberType: 0.0,
      },
      {
        text: [
          'A avaliação do PDI é realizada em até 3 etapas: ',
          <span>Auto avaliação, Avaliação do gestor</span>,
          ' e ',
          <span> Mediação.</span>,
        ],
        numberType: 0.1,
      },
      {
        text: [
          'Na ',
          <span>auto avaliação</span>,
          ' é necessário atribuir um nível de conhecimento para cada uma das questões da sua e de outras áreas.',
          <br />,
          <br />,
          ' Só será possível enviar o questionário depois de responder todos os itens.',
        ],
        numberType: 0.2,
      },
      {
        text: [
          'A ',
          <span>avaliação do gestor</span>,
          ' será feita com base no mesmo questionário respondido na auto avaliação para cada Semântico do time.',
        ],
        numberType: 0.3,
      },
      {
        text: [
          'A etapa da ',
          <span>mediação</span>,
          ' só será necessária se houver diferença significativa nas notas das etapas anteriores.',
        ],
        numberType: 0.4,
      },
      {
        text: [
          'Caso não seja viável responder o questionário de uma só vez, é possível ',
          <span>salvar para continuar depois</span>,
          '. Ao concluir o formulário, ainda será possível ',
          <span>revisar</span>,
          ' suas respostas e editar se necessário.',
        ],
        numberType: 0.5,
      },
      {
        text: [
          'Além de atribuir o nível de conhecimento a uma questão, também é possível marcar a opção ',
          <span>"Certificado"</span>,
          ', nesse caso será solicitado upload do comprovante (em PDF) de certificação na etapa de revisão do formulário. ',
          <br />,
          <br />,
          ' Certificados acadêmicos ou generalistas podem ser enviados em arquivo zipado (contendo apenas PDFs) na caixa outros certificado.',
        ],
        numberType: 0.6,
      },
      {
        text: [
          'O ',
          <span>resultado</span>,
          ' do PDI estará disponível após a consolidação das avaliações e terá uma nota de 0 a 0.999',
        ],
        numberType: 0.7,
      },
    ],
  },
  {
    context: 'evaluation',
    texts: [
      {
        text: [
          'A avaliação do PDI é realizada em até 3 etapas: ',
          <span>Auto avaliação, Avaliação do gestor</span>,
          ' e ',
          <span> Mediação.</span>,
        ],
        numberType: 1.0,
      },
      {
        text: [
          'A avaliação do gestor acontece depois da auto avaliação do funcionário.',
          <br />,
          'Na ',
          <span>auto avaliação</span>,
          ' o Semântico responderá o mesmo questionário que o líder sobre si mesmo',
        ],
        numberType: 1.1,
      },
      {
        text: [
          'Na ',
          <span>avaliação</span>,
          ' o gestor deve atribuir um nível de conhecimento para cada uma das questões da sua e outras áreas. Só será possível enviar a avaliação depois de responder todas as questões',
        ],
        numberType: 1.2,
      },
      {
        text: [
          'Caso não seja viável responder o questionário de uma só vez, é possível ',
          <span>salvar para continuar depois</span>,
          '. Ao concluir o formulário, ainda será possível ',
          <span>revisar</span>,
          ' suas respostas e editar se necessário.',
        ],
        numberType: 1.3,
      },
      {
        text: [
          'Quando o Semântico marcar "Certificado em uma questão, o gestor terá ',
          <span>acesso aos comprovantes</span>,
          ' de certificação antes de iniciar a avaliação. Os funcionários também poderão fazer upload de certificados acadêmicos ou generalistas que também estão disponíveis',
        ],
        numberType: 1.4,
      },
      {
        text: [
          'A ',
          <span>mediação</span>,
          ' só acontecerá se houver diferença significativa nas notas das etapas anteriores. Caso seja necessária, a nota do funcionário estará disponível para o gestor somente após essa etapa. Para o Semântico, a nota poderá ser visualizada depois da publicação pelo gestor.',
        ],
        numberType: 1.5,
      },
    ],
  },
  {
    context: 'mediation',
    texts: [
      {
        text: [
          'Na ',
          <span>mediação</span>,
          ' é necessário atribuir um nível de conhecimento para cada uma das questões disponíveis com relação ao Semântico avaliado. Só será possível enviar o questionário depois de responder todos os itens.',
        ],
        numberType: 2.0,
      },
      {
        text: [
          'Caso não seja viável responder o questionário de uma só vez, é possível ',
          <span>salvar para continuar depois</span>,
          '. Ao concluir o formulário, ainda será possível ',
          <span>revisar</span>,
          ' suas respostas e editar se necessário.',
        ],
        numberType: 2.1,
      },
    ],
  },
];

export default function Tutorial({ location, history }) {
  const { state } = location;
  const { context: pageContext } = state;

  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedTexts, setSelectedTexts] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const currentTexts = allTexts.filter(({ context }) => {
      if (pageContext === 'team-evaluation') return context === 'evaluation';

      return context === pageContext;
    });

    setSelectedImages(
      pageContext === 'mediation'
        ? mediationImages
        : pageContext === 'evaluation' || pageContext === 'team-evaluation'
        ? evaluationImages
        : selfEvaluationImages,
    );

    setSelectedTexts(currentTexts[0]?.texts);
  }, [state]);

  const handleCheck = () => setIsChecked(prevState => !prevState);

  return (
    <PageStructure
      title="Plano de Desenvolvimento Individial - Tutorial"
      subtitle="Entenda como preencher a autoavaliação."
    >
      <MDBRow>
        <MDBCol lg="10" sm="12">
          <S.Container>
            <Slider
              data={selectedImages}
              currentIndex={currentImage}
              setSelectedIndex={setCurrentImage}
              currentname=""
            >
              <S.Description type={selectedTexts[currentImage]?.numberType}>
                {selectedTexts[currentImage]?.text}
              </S.Description>
              <S.Image
                src={selectedImages[currentImage]}
                alt={`${currentImage + 1}º imagem do tutorial`}
              />
            </Slider>
            <S.Actions>
              <Checkbox
                id="noViewMore"
                labelText="Não mostrar novamente"
                checked={isChecked}
                onChange={handleCheck}
              />
              <S.Skip
                onClick={() =>
                  currentImage !== selectedImages.length - 1
                    ? setCurrentImage(selectedImages.length - 1)
                    : history.push({ pathname: '/auth/pdi/evaluation', state })}
              >
                {currentImage !== selectedImages.length - 1
                  ? 'Pular tutorial'
                  : 'Fechar tutorial'}
              </S.Skip>
            </S.Actions>
          </S.Container>
        </MDBCol>
      </MDBRow>
    </PageStructure>
  );
}

Tutorial.defaultProps = {
  location: {},
  history: {},
};

Tutorial.propTypes = {
  location: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
  history: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  ),
};
